export default {
  horecaLocations: [],
};
